import { _DELETE, _GET, _POST, createAutoRequest, createRequestApi } from "@/lib/request";
import { LOGIN_PATH, OPR_SESSION_TOKEN } from "@/constants";
import type { AxiosError, AxiosResponse } from "axios";
import { message } from "antd";
import { DakeListChannelsExportReq } from "@/data-contracts";

export type { ApiResult, ConfigHeaders } from "@/lib/request";
export { _POST, _GET, _DELETE };

const dakeOprAdminRequest = createAutoRequest(
  {
    baseURL: process.env.ENV_REPLACE_API_URL || "",
    timeout: 30000,
  },
  function (response: AxiosResponse) {
    // 响应拦截
    return response;
  },
  function (error: AxiosError) {
    // 拦截错误
    return Promise.reject(error);
  }
);

const request = createRequestApi(dakeOprAdminRequest, {
  getToken: () => window.localStorage.getItem(OPR_SESSION_TOKEN) || "",
  loginPath: LOGIN_PATH,
});

export type RequestExportOptions<T> = {
  params?: T;
  callback?: (url: string) => void;
  method?: string;
};

export const requestExport = async <T>(
  api: string,
  { params, callback, method = "post" }: RequestExportOptions<T>
) => {
  try {
    const res = await fetch((process.env.ENV_REPLACE_API_URL || "") + api, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: window.localStorage.getItem(OPR_SESSION_TOKEN) || "",
      },
      body: JSON.stringify(params || {}),
    });
    const blob = await res.blob();
    const url_1 = URL.createObjectURL(blob);
    callback?.(url_1);
    URL.revokeObjectURL(url_1);
  } catch (error) {
    // @ts-ignore
    message.error(error?.data?.msg ?? "网络错误");
    console.error("Error downloading file:", error);
    return Promise.reject(error);
  }
};

/**
 *
 * 调用方法
 *
 * */
export default request;
